import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FroalaViewModule } from 'angular-froala-wysiwyg';
import { TextViewerComponent } from './text-viewer.component';
import { TableScrollPipe } from './table-scroll.pipe';
import { HighlightPipeModule } from '@schoolbelle/shared/pipes';
import { MailmergedPipe } from './mailmerged.pipe';
import { ImageResizedPipe } from './image-resized.pipe';

@NgModule({
  declarations: [TextViewerComponent, MailmergedPipe, TableScrollPipe, ImageResizedPipe],
  imports: [
    CommonModule,
    FroalaViewModule.forRoot(),
    HighlightPipeModule,
  ],
  exports: [
    TextViewerComponent,
    CommonModule,
    FroalaViewModule,
    HighlightPipeModule,
    MailmergedPipe, TableScrollPipe, ImageResizedPipe,
  ]
})
export class TextViewerModule { }
